// Shared notification constants and utilities
export const NOTIFICATION_CONFIG = {
  TOP_OFFSET: 76,
  DURATION: 10,
  SUCCESS_DURATION: 5
};

export const NOTIFICATION_TYPES = {
  CREATE_SUCCESS: 'CREATE_SUCCESS',
  EDIT_SUCCESS: 'EDIT_SUCCESS',
  CREATE_OR_EDIT_ERROR: 'CREATE_OR_EDIT_ERROR',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_ERROR: 'DELETE_ERROR',
  CONVERSION_DELETE_ERROR: 'CONVERSION_DELETE_ERROR',
  PDF_EXPORT_ERROR: 'PDF_EXPORT_ERROR'
} as const;

export type NotificationType = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];
